import { SearchPromotionItem } from '../../SearchHeader/Suggestions/EmptySearchSuggestions/SearchPromotionResponse.type';
import { OverflowMenuContainer, OverflowMenuItem } from './OverflowSpecialtyOption.styles';

interface Props {
  overflowSpecialties: SearchPromotionItem[];
  onClick: (specialty: string) => void;
}

export const OverflowMenu = ({ overflowSpecialties, onClick }: Props) => (
  <OverflowMenuContainer>
    {overflowSpecialties.map((specialty, idx) => (
      <OverflowMenuItem key={idx} onClick={() => onClick(specialty.title)}>
        {specialty.topNavTitle ?? specialty.title}
      </OverflowMenuItem>
    ))}
  </OverflowMenuContainer>
);
